import {Address} from "../domain/address";
import {User} from "../domain/user";

export class CheckoutDTO {

    public email: string = null;
    public phone: string = null;
    public billingFirstName: string = null;
    public billingLastName: string = null;
    public billingStreet: string = null;
    public billingApartment: string = null;
    public billingCity: string = null;
    public billingPostalCode: string = null;
    public billingRegionCode: string = null;
    public billingPhone: string = null;
    public paymentMethod: string = "credit-card";
    public couponCode: string;

    public constructor(json: any = null) {
        if(json != null) {
            for(let property in json) {
                this[property] = json[property];
            }
        }
    }

    public getBillingAddress(): Address {

        let returnValue: Address;

        returnValue = new Address();
        returnValue.firstName = this.billingFirstName;
        returnValue.lastName = this.billingLastName;
        returnValue.street = this.billingStreet;
        returnValue.apartment = this.billingApartment;
        returnValue.city = this.billingCity;
        returnValue.postalCode = this.billingPostalCode;
        returnValue.regionCode = this.billingRegionCode;
        returnValue.phone = this.billingPhone;
        return returnValue;

    }

    public setBillingAddress(address: Address) {

        if(address != null) {
            this.billingFirstName = address.firstName;
            this.billingLastName = address.lastName;
            this.billingPhone = address.phone;
            this.billingStreet = address.street;
            this.billingCity = address.city;
            this.billingApartment = address.apartment;
            this.billingPostalCode = address.postalCode;
            this.billingRegionCode = address.regionCode;
        }
    }


}
